import PropTypes from 'prop-types';

const
    types = ['credit', 'purchase', 'service', 'charge'],

    invoiceType = {
        id: PropTypes.string.isRequired,
        number: PropTypes.string.isRequired,
        date: PropTypes.string.isRequired,
        due: PropTypes.string,
        paid: PropTypes.bool.isRequired,
        pending: PropTypes.bool.isRequired,
        status: PropTypes.string.isRequired,
        amount: PropTypes.number.isRequired,
        credit: PropTypes.number.isRequired,
        billing: (
            PropTypes.shape({
                number: PropTypes.string.isRequired,
                month: PropTypes.number.isRequired,
                year: PropTypes.number.isRequired,
                name: PropTypes.string.isRequired,
                address1: PropTypes.string.isRequired,
                address2: PropTypes.string.isRequired,
                city: PropTypes.string.isRequired,
                zip: PropTypes.string.isRequired
            })),
        lines: (
            PropTypes.arrayOf(
                PropTypes.shape({
                    subscriber: (
                        PropTypes.shape({
                            devices: (
                                PropTypes.arrayOf(
                                    PropTypes.shape({
                                        id: PropTypes.string.isRequired,
                                        sku: PropTypes.string.isRequired,
                                        sim: PropTypes.string.isRequired,
                                        status: PropTypes.string.isRequired,
                                        name: PropTypes.string.isRequired
                                    })
                                    .isRequired)
                                .isRequired)
                        })),
                    amount: PropTypes.number.isRequired,
                    tax: PropTypes.number.isRequired,
                    items: (
                        PropTypes.arrayOf(
                            PropTypes.shape({
                                model: PropTypes.string.isRequired,
                                sku: PropTypes.string.isRequired,
                                quantity: PropTypes.number.isRequired,
                                amount: PropTypes.number.isRequired,
                                tax: PropTypes.number.isRequired,
                                taxes: (
                                    PropTypes.arrayOf(
                                        PropTypes.shape({
                                            name: PropTypes.string.isRequired,
                                            amount: PropTypes.number.isRequired
                                        })
                                        .isRequired)
                                    .isRequired)
                            })
                            .isRequired)
                        .isRequired)
                }))
            .isRequired),
        type: PropTypes.oneOf(types).isRequired
    },

    orderType = {
        id: PropTypes.number.isRequired,
        number: PropTypes.string.isRequired,
        date: PropTypes.string.isRequired,
        cancelled: PropTypes.bool.isRequired,
        backordered: PropTypes.bool.isRequired,
        cancellable: PropTypes.bool.isRequired,
        amount: PropTypes.number.isRequired,
        items: (
            PropTypes.arrayOf(
                PropTypes.shape({
                    sku: PropTypes.string.isRequired,
                    quantity: PropTypes.number.isRequired,
                    amount: PropTypes.number.isRequired,
                    tax: PropTypes.number.isRequired,
                    taxes: (
                        PropTypes.arrayOf(
                            PropTypes.shape({
                                name: PropTypes.string.isRequired,
                                amount: PropTypes.number.isRequired
                            })
                            .isRequired)
                        .isRequired)
                })
                .isRequired))
    },

    returnOfferType = {
        id: PropTypes.string.isRequired,
        sku: PropTypes.string.isRequired,
        device: PropTypes.string
    },

    returnOrderType = {
        original: (
            PropTypes.shape({
                price: PropTypes.number.isRequired,
                tax: PropTypes.number.isRequired
            })
            .isRequired),
        discounts: (
            PropTypes.shape({
                price: PropTypes.number.isRequired,
                tax: PropTypes.number.isRequired
            })
            .isRequired),
        total: (
            PropTypes.shape({
                price: PropTypes.number.isRequired,
                tax: PropTypes.number.isRequired
            })
            .isRequired),
        lines: (
            PropTypes.arrayOf(
                PropTypes.shape({
                    sku: PropTypes.string.isRequired,
                    device: PropTypes.string,
                    original: (
                        PropTypes.shape({
                            price: PropTypes.number.isRequired,
                            tax: PropTypes.number.isRequired
                        })
                        .isRequired),
                    discounts: (
                        PropTypes.shape({
                            price: PropTypes.number.isRequired,
                            tax: PropTypes.number.isRequired
                        })
                        .isRequired),
                    total: (
                        PropTypes.shape({
                            price: PropTypes.number.isRequired,
                            tax: PropTypes.number.isRequired
                        })
                        .isRequired),
                    taxes: (
                        PropTypes.arrayOf(
                            PropTypes.shape({
                                name: PropTypes.string.isRequired,
                                amount: PropTypes.number.isRequired
                            })
                            .isRequired)
                        .isRequired)
                })
                .isRequired)
            .isRequired)
    },

    prepayType = {
        id: PropTypes.string,
        begin: PropTypes.string,
        end: PropTypes.string,
        active: PropTypes.bool.isRequired,
        cancellable: PropTypes.bool.isRequired
    },

    deviceType = {
        id: PropTypes.string.isRequired,
        sku: PropTypes.string.isRequired,
        sim: PropTypes.string.isRequired,
        status: PropTypes.string.isRequired,
        name: PropTypes.string.isRequired,
        prepay: (
            PropTypes.shape(
                prepayType)
            .isRequired)
    },

    subscriberType = {
        devices: (
            PropTypes.arrayOf(
                PropTypes.shape(
                    deviceType)
                .isRequired)
            .isRequired),
        line: PropTypes.string.isRequired
    },

    unpaidInvoicesType = {
        balance: PropTypes.number.isRequired,
        pending: PropTypes.bool.isRequired,
        unresolved: PropTypes.bool.isRequired
    },

    paymentType = {
        type: PropTypes.oneOf(['ach', 'cc']).isRequired,
        default: PropTypes.bool.isRequired,
        token: PropTypes.string.isRequired,
        ach: (
            PropTypes.shape({
                number: PropTypes.string.isRequired
            })),
        cc: (
            PropTypes.shape({
                number: PropTypes.string.isRequired,
                month: PropTypes.number.isRequired,
                year: PropTypes.number.isRequired,
                type: PropTypes.string.isRequired
            }))
    };

export {
    invoiceType,
    orderType,
    returnOfferType,
    returnOrderType,
    prepayType,
    deviceType,
    subscriberType,
    unpaidInvoicesType,
    paymentType
};
